<app-header></app-header>
<div class="main-container">
  <div class="company">
    <div class="company__container">
      <ng-container *ngIf="userService.userInfo$ | async as data">
        <form class="company__form" [formGroup]="form">
          <div class="company__form-block">
            <div class="company__form-block__title title-with-icon">
              {{ 'form.subtitles.main_info' | translate }}
              <span
                class="icon icon-Info icon-hover"
                [matTooltip]="'form.subtitles.your_name_is_used_as_default' | translate"
                matTooltipClass="custom-tooltip-xl"></span>
            </div>
            <div class="company__form-block__fields">
              <mat-form-field>
                <mat-label>{{ 'form.fields.email' | translate }}</mat-label>
                <input formControlName="email" matInput [placeholder]="'form.fields.email_placeholder' | translate" trim />
                <mat-error *ngIf="form.get('email')?.hasError('pattern')">{{ 'form.errors.email_invalid' | translate }}</mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'form.fields.first_name' | translate }}</mat-label>
                <input formControlName="firstName" matInput [placeholder]="'form.fields.first_name_placeholder' | translate" trim="blur" />
                <mat-error *ngIf="form.get('firstName')?.hasError('pattern'); else firstNameLengthError">{{
                  'form.errors.first_name_pattern' | translate
                }}</mat-error>
                <ng-template #firstNameLengthError>
                  <mat-error *ngIf="form.get('firstName')!.hasError('minlength') || form.get('firstName')!.hasError('maxlength')"
                    >{{
                      'form.errors.first_name_length'
                        | translate
                          : {
                              minLength: RULES.USER_NAME_MIN_LENGTH,
                              maxLength: RULES.USER_NAME_MAX_LENGTH,
                              currentLength: form.get('firstName')?.value?.length || 0
                            }
                    }}
                  </mat-error></ng-template
                >
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'form.fields.last_name' | translate }}</mat-label>
                <input formControlName="lastName" matInput [placeholder]="'form.fields.last_name_placeholder' | translate" trim="blur" />
                <mat-error *ngIf="form.get('lastName')?.hasError('pattern'); else lastNameLengthError">{{
                  'form.errors.last_name_pattern' | translate
                }}</mat-error>
                <ng-template #lastNameLengthError>
                  <mat-error *ngIf="form.get('lastName')!.hasError('minlength') || form.get('lastName')!.hasError('maxlength')"
                    >{{
                      'form.errors.last_name_length'
                        | translate
                          : {
                              minLength: RULES.USER_NAME_MIN_LENGTH,
                              maxLength: RULES.USER_NAME_MAX_LENGTH,
                              currentLength: form.get('lastName')?.value?.length || 0
                            }
                    }}
                  </mat-error>
                </ng-template>
              </mat-form-field>
            </div>
          </div>

          <div class="company__form-block__title heading">{{ 'form.subtitles.signin_methods' | translate }}</div>

          <div class="company__form-block single-row">
            <div class="company__form-block__title">{{ 'form.subtitles.signin_methods_password' | translate }}</div>
            <div class="company__form-block__fields">
              <div class="company__form-block__add-btn">
                <button class="btn-main btn-secondary btn-xs btn-border" (click)="data.authMethods.password ? onChangePassword() : onSetPassword()">
                  {{ data.authMethods.password ? ('actions.change' | translate) : ('actions.set' | translate) }}
                </button>
              </div>
            </div>
          </div>

          <div class="company__form-block single-row">
            <div class="company__form-block__title">{{ 'form.subtitles.signin_methods_google' | translate }}</div>
            <div class="company__form-block__fields">
              <div class="company__form-block__add-btn">
                <ng-container *ngIf="data.authMethods.google">
                  <button class="btn-main btn-secondary btn-xs btn-square disabled">
                    <span class="icon-Checked color-green"></span>
                    {{ 'actions.linked' | translate }} <img src="./assets/images/google-icon.svg" alt="Google" />
                  </button>

                  <button
                    class="btn-main btn-xs"
                    [ngClass]="data.authMethods.password ? 'btn-secondary btn-border' : 'btn-grey not-active'"
                    [matTooltip]="data.authMethods.password ? null : ('messages.unlink_google_warning' | translate)"
                    (click)="data.authMethods.password ? onUnlinkGoogle() : null">
                    {{ 'actions.unlink' | translate }}
                  </button>
                </ng-container>

                <ng-container *ngIf="!data.authMethods.google">
                  <app-google-signin-button [isLink]="true"></app-google-signin-button>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="company__form-block__btns">
            <button class="btn-main btn-primary btn-xl" (click)="onSubmit()" [matTooltip]="!form.valid ? ('messages.form_submit_tooltip' | translate) : null">
              {{ 'actions.save_changes' | translate }}
            </button>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
  <app-loader></app-loader>
</div>
<app-footer></app-footer>
